import suppliers from './supplier';
import state from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  modules: {
    suppliers
  },
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
